import { GET_TYPE_PARAMETERS, GET_TYPE_PARAMETERS_SUCCESS, GET_TYPE_PARAMETERS_ERROR} from './actionTypes';

const initialState = {
    errorGetTypeParams: "",
    loadingGetTypeParams: false,
    typeParams: null,
    successTypeParams: ""
}

const getTypeParams = (state = initialState, action) => {
    switch (action.type) {
        case GET_TYPE_PARAMETERS:
            state = {
                ...state,
                loadingGetTypeParams: true
            }
            break;
        case GET_TYPE_PARAMETERS_SUCCESS:
            state = {
                ...state,
                loadingGetTypeParams: false,
                typeParams: action.payload.params, 
                successTypeParams: action.payload.message
            }
            break;
        case GET_TYPE_PARAMETERS_ERROR:
            state = { ...state, errorGetTypeParams: action.payload, loadingGetTypeParams: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getTypeParams;